import { Panel, PanelProps } from '@/app/components/Panel/Panel'
import { ICourse } from '@/types/course'
import Image from 'next/image'

type EducationProviderPanelProps = {
  courseInfo: Pick<ICourse, 'educationProvider'>
} & PanelProps

export function EducationProviderPanel({
  courseInfo,
  ...props
}: EducationProviderPanelProps) {
  const { educationProvider } = courseInfo

  return (
    <Panel {...props} className={`!py-4 ${props.className}`}>
      <div className="flex items-center gap-4">
        <Image
          src={educationProvider?.logoUrl}
          alt={`${educationProvider?.name} logo`}
          width={58}
          height={58}
          className="rounded-full w-14 h-14"
          onError={(e) => {
            e.currentTarget.onerror = null
            e.currentTarget.remove()
          }}
        />
        <p className="font-sans text-lg font-semibold leading-6">
          {educationProvider?.name}
        </p>
      </div>
      <p className="text-sm leading-6 text-gray-light">
        {educationProvider?.bio}
      </p>
    </Panel>
  )
}
